import React, { useState, useEffect } from 'react'
import ReactModal from 'react-modal'
import { useMutation } from '@apollo/client/react'
import { toast } from 'react-toastify'
import cn from 'classnames'
import { useRouter } from 'next/router'
// Components
import Button from '../newButton/Button'
import ToastModal from '@/components/breeder/toastModal'
import Loader from '../newLoader/Loader'
// Utils
import { valEmail } from '../apply/lib/utils'
import styles from './ambassadorModal.module.scss'
import { CREATE_AMBASSADOR, RESEND_EMAIL_AMBASSADOR } from '@/graphql/index'

export default function AmbassadorModal({ isOpen, close, setUserRegisterd }) {
  const [data, setData] = useState({
    name: '',
    lastName: '',
    email: '',
  })

  const router = useRouter()
  const [showError, setShowError] = useState(false)

  const [submittedData, setSubmittedData] = useState(false)

  const [submit] = useMutation(CREATE_AMBASSADOR, {
    onCompleted: (data) => {
      if (data?.createAmbassador?.errorMessage) {
        toast(
          <ToastModal
            theme="error"
            title="Error"
            message={data?.createAmbassador?.errorMessage}
            onClick={() => {
              toast.dismiss()
            }}
          />
        )
      }
      if (data?.createAmbassador?.verified) {
        router.push(`/referral/${data?.createAmbassador?.hash}`)
      } else {
        setSubmittedData(true)
      }
    },
    onError: (error) => {
      toast(
        <ToastModal
          position="bottom-right"
          theme="error"
          title="Error"
          message={`Unknown error, please try again. Error:${error}`}
          onClick={() => {
            toast.dismiss()
          }}
        />
      )
    },
  })
  const [resend, { loading }] = useMutation(RESEND_EMAIL_AMBASSADOR)

  const handleSubmit = () => {
    // Validates not null fields
    if (showError || !valEmail(data.email)) {
      return setShowError(true)
    } else {
      submit({
        variables: {
          user: {
            name: data?.name,
            lastName: data?.lastName,
            email: data?.email,
          },
        },
      })
    }
  }
  const hanldeResend = () => {
    resend({
      variables: {
        data: {
          email: data?.email,
        },
      },
    })
    setSubmittedData(true)
  }
  // Form validation
  const isCompleted =
    data.name !== '' && data.lastName !== '' && data.email !== ''

  useEffect(() => {
    if (isCompleted || valEmail(data.email)) setShowError(false)
  }, [isCompleted, data.email])

  return (
    <ReactModal
      isOpen={isOpen}
      overlayClassName={styles.modalOverlay}
      className={styles.modal}
      onRequestClose={() => close()}
    >
      <div className={styles.closeButton} onClick={() => close()}>
        <img src="/close-modal-grey.svg" alt="close icon" />
      </div>
      {!submittedData ? (
        <div className={styles.content}>
          {/* // VIEW FORM */}
          <p>
            Welcome to the <b>Mawoo Pets Ambassador Program.</b> Enter your
            details below to get your unique referral code.{' '}
          </p>
          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.inputs}>
              <div className={styles.firstLine}>
                <div className={styles.inputBox}>
                  <input
                    className={cn({
                      [styles.field]: true,
                      [styles.showError]: data.name === '' && showError,
                    })}
                    type="text"
                    required="required"
                    value={data.name}
                    onChange={(e) => setData({ ...data, name: e.target.value })}
                  />
                  <span
                    className={cn({
                      [styles.label]: true,
                      [styles.message]: data.name === '' && showError,
                    })}
                  >
                    First Name
                  </span>
                  {showError && data.name === '' && (
                    <div className={styles.errorMessage}>
                      <div className={styles.icon} />
                      <div className={styles.error}>
                        <div className={styles.message}>
                          Please enter a valid name
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className={styles.inputBox}>
                  <input
                    className={cn({
                      [styles.field]: true,
                      [styles.showError]: data.lastName === '' && showError,
                    })}
                    type="text"
                    required="required"
                    value={data.lastName}
                    onChange={(e) =>
                      setData({ ...data, lastName: e.target.value })
                    }
                  />
                  <span
                    className={cn({
                      [styles.label]: true,
                      [styles.message]: data.lastName === '' && showError,
                    })}
                  >
                    Last Name
                  </span>
                  {showError && data.lastName === '' && (
                    <div className={styles.errorMessage}>
                      <div className={styles.icon} />
                      <div className={styles.error}>
                        <div className={styles.message}>
                          Please enter a valid last name
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.inputBox}>
                <input
                  className={cn({
                    [styles.field]: true,
                    [styles.showError]: !valEmail(data.email) && showError,
                  })}
                  type="text"
                  required="required"
                  value={data.email}
                  onChange={(e) => setData({ ...data, email: e.target.value })}
                />
                <span
                  className={cn({
                    [styles.label]: true,
                    [styles.message]: !valEmail(data.email) && showError,
                  })}
                >
                  Email
                </span>
                {showError && !valEmail(data.email) && (
                  <div className={styles.errorMessage}>
                    <div className={styles.icon} />
                    <div className={styles.error}>
                      <div className={styles.message}>
                        Please enter a valid email address
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.btnSection}>
              <Button
                title="Continue"
                onClick={handleSubmit}
                theme={
                  isCompleted
                    ? ['medium', 'green-solid']
                    : ['medium', 'grey-solid']
                }
              />
            </div>
          </form>
        </div>
      ) : (
        <div className={styles.content}>
          {/* // VIEW SENDING E-MAIL */}
          <h2>A final step - verify your email</h2>
          <section className={styles.finalMessage}>
            <p>
              We just sent an email to you at <b>{data.email}</b>. Please check
              your inbox and click the link to verify your email.{' '}
            </p>
            <p>
              <b>The email is not in your inbox?</b> Check your spam folder or
              click below to re send.
            </p>
            <div className={styles.btnSection}>
              <Button
                title="I’m all set"
                onClick={() => {
                  setUserRegisterd(true)
                  close()
                }}
                theme={['medium', 'green-solid']}
              />
              {loading ? (
                <div className={styles.loader}>
                  <Loader theme="short" />
                </div>
              ) : (
                <Button
                  title="Re send email"
                  onClick={() => hanldeResend()}
                  theme={['medium', 'green-solid']}
                />
              )}
            </div>
          </section>
        </div>
      )}
    </ReactModal>
  )
}
